var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('Editor',{attrs:{"api-key":"qmmn21opcrrblgzue2p7mj51cdpyxgj8xq6sc3amhko97ehp","init":_vm.editorInit,"value":_vm._f("richText")(_vm.value)},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }